import {
    bexHttpClient
} from '../../clients';
import {
    ProjectOProxyRequest,
    ProjectOProxyAPIResponse
} from '../bexService.types';

/**
 * Project O (Mind) service — DIRECT calls through Envoy.
 *
 * Formerly wrapped every call in the bex-server `/projecto/proxy` envelope
 * ({endPoint, method, body}); now the endpoint is called directly:
 * `/api/<endPoint>` → Envoy (JWT verified at the edge, x-api-key injected)
 * → Mind. Callers keep passing the same relative endpoints as before, e.g.
 * "projecto/config/api/v1/mcp/discover".
 */
class ProjectOService {
    /**
     * Sends a request directly to a Mind endpoint (via Envoy).
     * @param {string} url - The Mind endpoint, e.g. "projecto/config/api/v1/...".
     * @param {Object} options - The request options.
     * @param {string} options.method - The request method
     * @param {Object} [options.data] - The data to be sent.
     * @param {string} [options.timeout] - The request timeout in milliseconds.
     * @returns {Promise<Object>} The response body from Mind.
     */
    async performRequest(url: string, options: { method?: ProjectOProxyRequest['method']; data?: ProjectOProxyRequest['body']; timeout?: number; headers?: Record<string, string> } = {}): Promise<ProjectOProxyAPIResponse['data']> {
        const response = await this.performRequestWithFullResponse(url, options);
        return response.data;
    }

    /**
     * Same as performRequest but returns the full axios response.
     */
    async performRequestWithFullResponse(url: string, options: { method?: ProjectOProxyRequest['method']; data?: ProjectOProxyRequest['body']; timeout?: number; headers?: Record<string, string> } = {}): Promise<ProjectOProxyAPIResponse> {
        const {
            method = 'GET', data, timeout = 120000, headers
        } = options;
        const response = await bexHttpClient.request({
            url: `/${url.replace(/^\/+/, '')}`,
            method,
            data,
            headers,
            timeout,
        });
        return response as ProjectOProxyAPIResponse;
    }
}

const projectOService = new ProjectOService();
export { projectOService };
